import { handleRequest } from "../utilities/requestHandler";

export const getMachineModelFiles = (machineNumber) => 
    handleRequest("get", `/machines/models/${machineNumber}/files`);

export const uploadMachineModels = (formData, options = {}) => {
    const { headers: extraHeaders, ...rest } = options || {};
    return handleRequest("post", "/machines/upload", formData, {
        ...rest,
        headers: {
            "Content-Type": "multipart/form-data",
            ...(extraHeaders || {}),
        },
    });
};

export const deleteMachineModelFile = (machineNumber, fileKey) =>
    handleRequest("delete", `/machines/models/${machineNumber}/files/${fileKey}`);

// Every file attached to a machine's 3D model -- published GLB, generated BOM
// output, HTML viewer, thumbnail and uploaded STEP sources. Super admin only,
// enforced server-side.
export const getMachineModelArtifacts = (machineNumber) =>
    handleRequest("get", `/machines/models/${machineNumber}/artifacts`);

// Deletes only the selected artifacts. Keys come from getMachineModelArtifacts;
// the server resolves them against its own scan, so no path is sent from here.
export const deleteMachineModelArtifacts = (machineNumber, keys) =>
    handleRequest("post", `/machines/models/${machineNumber}/artifacts/delete`, { keys });

export const replaceMachineModelFile = (machineNumber, fileKey, formData) =>
    handleRequest("post", `/machines/models/${machineNumber}/files/${fileKey}/replace`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
